import * as Types from '../../../@types/graphql-types';

import { SponsoredAdFragmentFragment } from '../../../pages/graphql/queries/GetPopularTitles.query';
import gql from 'graphql-tag';
import { SponsoredAdFragmentFragmentDoc } from '../../../pages/graphql/queries/GetPopularTitles.query';
export type GetSimilarTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	titleId: Types.Scalars['ID'];
	language: Types.Scalars['Language'];
	filters?: Types.Maybe<Types.TitleFilter>;
	format?: Types.Maybe<Types.ImageFormat>;
	backdropProfile?: Types.Maybe<Types.BackdropProfile>;
	platform?: Types.Platform;
	allowSponsoredRecommendations?: Types.Maybe<Types.SponsoredRecommendationsInput>;
}>;

export type GetSimilarTitlesQuery = { __typename?: 'Query' } & {
	node?: Types.Maybe<
		| ({ __typename?: 'Article' } & Pick<Types.Article, 'id'>)
		| ({ __typename?: 'Author' } & Pick<Types.Author, 'id'>)
		| ({ __typename?: 'Bundle' } & Pick<Types.Bundle, 'id'>)
		| ({ __typename?: 'Device' } & Pick<Types.Device, 'id'>)
		| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'>)
		| ({ __typename?: 'GenericTitleList' } & Pick<Types.GenericTitleList, 'id'>)
		| ({ __typename?: 'Genre' } & Pick<Types.Genre, 'id'>)
		| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & {
					similarTitlesV2: { __typename?: 'SimilarTitlesConnection' } & {
						edges?: Types.Maybe<
							Array<
								{ __typename?: 'SimilarTitlesEdge' } & {
									node:
										| ({ __typename?: 'Movie' } & SimilarTitle_Movie_Fragment)
										| ({ __typename?: 'Show' } & SimilarTitle_Show_Fragment);
								}
							>
						>;
						sponsoredAd?: Types.Maybe<
							{ __typename?: 'SponsoredRecommendationAd' } & SponsoredAdFragmentFragment
						>;
					};
				})
		| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'>)
		| ({ __typename?: 'Offer' } & Pick<Types.Offer, 'id'>)
		| ({ __typename?: 'Package' } & Pick<Types.Package, 'id'>)
		| ({ __typename?: 'Page' } & Pick<Types.Page, 'id'>)
		| ({ __typename?: 'Person' } & Pick<Types.Person, 'id'>)
		| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'>)
		| ({ __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
					similarTitlesV2: { __typename?: 'SimilarTitlesConnection' } & {
						edges?: Types.Maybe<
							Array<
								{ __typename?: 'SimilarTitlesEdge' } & {
									node:
										| ({ __typename?: 'Movie' } & SimilarTitle_Movie_Fragment)
										| ({ __typename?: 'Show' } & SimilarTitle_Show_Fragment);
								}
							>
						>;
						sponsoredAd?: Types.Maybe<
							{ __typename?: 'SponsoredRecommendationAd' } & SponsoredAdFragmentFragment
						>;
					};
				})
		| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'>)
		| ({ __typename?: 'SportCompetitionV2' } & Pick<Types.SportCompetitionV2, 'id'>)
		| ({ __typename?: 'SportCompetitorV2' } & Pick<Types.SportCompetitorV2, 'id'>)
		| ({ __typename?: 'Url' } & Pick<Types.Url, 'id'>)
	>;
};

export type GetSimilarUpcomingTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
	filters?: Types.Maybe<Types.TitleFilter>;
}>;

export type GetSimilarUpcomingTitlesQuery = { __typename?: 'Query' } & {
	newTitles: { __typename?: 'NewTitlesConnection' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'NewTitlesEdge' } & {
					node:
						| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & SimilarTitle_Movie_Fragment)
						| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
									content: { __typename?: 'SeasonContent' } & Pick<
										Types.SeasonContent,
										'title' | 'posterUrl' | 'fullPath'
									> & {
											backdrops: Array<
												{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>
											>;
											scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
										};
								});
				}
			>
		>;
	};
};

export type SimilarTitle_Movie_Fragment = { __typename?: 'Movie' } & Pick<
	Types.Movie,
	'id' | 'objectId' | 'objectType'
> & {
		seenlistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
		content: { __typename?: 'MovieContent' } & Pick<Types.MovieContent, 'title' | 'posterUrl' | 'fullPath'> & {
				backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
				scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
			};
		watchlistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
		likelistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
		dislikelistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
	};

export type SimilarTitle_Show_Fragment = { __typename?: 'Show' } & Pick<
	Types.Show,
	'id' | 'objectId' | 'objectType'
> & {
		seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'progress' | 'seenEpisodeCount'>;
		content: { __typename?: 'ShowContent' } & Pick<Types.ShowContent, 'title' | 'posterUrl' | 'fullPath'> & {
				backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
				scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
			};
		watchlistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
		likelistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
		dislikelistEntry?: Types.Maybe<{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>>;
	};

export type SimilarTitleFragment = SimilarTitle_Movie_Fragment | SimilarTitle_Show_Fragment;

export const SimilarTitleFragmentDoc = gql`
	fragment SimilarTitle on MovieOrShow {
		id
		objectId
		objectType
		content(country: $country, language: $language) {
			title
			posterUrl
			fullPath
			backdrops {
				backdropUrl
			}
			scoring {
				imdbScore
			}
		}
		watchlistEntry {
			createdAt
		}
		likelistEntry {
			createdAt
		}
		dislikelistEntry {
			createdAt
		}
		... on Movie {
			seenlistEntry {
				createdAt
			}
		}
		... on Show {
			seenState(country: $country) {
				progress
				seenEpisodeCount
			}
		}
	}
`;
export const GetSimilarTitlesDocument = gql`
	query GetSimilarTitles(
		$country: Country!
		$titleId: ID!
		$language: Language!
		$filters: TitleFilter
		$format: ImageFormat
		$backdropProfile: BackdropProfile
		$platform: Platform! = WEB
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
	) {
		node(id: $titleId) {
			id
			... on MovieOrShow {
				similarTitlesV2(
					country: $country
					filter: $filters
					allowSponsoredRecommendations: $allowSponsoredRecommendations
				) {
					edges {
						node {
							...SimilarTitle
						}
					}
					sponsoredAd {
						...SponsoredAdFragment
					}
				}
			}
		}
	}
	${SimilarTitleFragmentDoc}
	${SponsoredAdFragmentFragmentDoc}
`;
export const GetSimilarUpcomingTitlesDocument = gql`
	query GetSimilarUpcomingTitles($country: Country!, $language: Language!, $filters: TitleFilter) {
		newTitles(country: $country, pageType: UPCOMING, filter: $filters) {
			edges {
				node {
					id
					... on MovieOrShow {
						...SimilarTitle
					}
					... on Season {
						content(country: $country, language: $language) {
							title
							posterUrl
							fullPath
							backdrops {
								backdropUrl
							}
							scoring {
								imdbScore
							}
						}
					}
				}
			}
		}
	}
	${SimilarTitleFragmentDoc}
`;
